import React, { useState, useEffect } from 'react';
import apiService from '../services/apiService';

function Contact() {
  const [settings, setSettings] = useState({});
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');
  const [submitError, setSubmitError] = useState('');

  useEffect(() => {
    apiService.getSettings()
      .then(response => setSettings(response.data.settings))
      .catch(error => console.error('Error loading settings:', error));
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    // Clear messages when user starts typing
    if (submitMessage || submitError) {
      setSubmitMessage('');
      setSubmitError('');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage('');
    setSubmitError('');
    
    try {
      const response = await apiService.sendContactMessage(formData);
      setSubmitMessage(response.data.message || 'Thank you for your message! We will get back to you soon.');
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: ''
      });
    } catch (error) {
      setSubmitError(
        error.response?.data?.message || 
        'Failed to send message. Please try again later.'
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-page">
      <section className="hero-section" style={{backgroundImage: 'url(/images/contact-bg.jpg)', height: '60vh'}}>
        <div className="hero-content">
          <h1 className="hero-title">CONTACT US</h1>
        </div>
      </section>

      <section className="section section-light">
        <div className="container">
          <div className="two-column">
            <div>
              <h2 className="section-title">GET IN TOUCH</h2>
              <p className="section-text" style={{marginBottom: '30px'}}>
                Have questions or feedback? We'd love to hear from you. Reach out to us and we'll respond as soon as we can.
              </p>
              
              <div style={{marginBottom: '40px'}}>
                <div className="contact-item">
                  <p className="contact-label">PHONE</p>
                  <p className="contact-value">
                    <a href={`tel:${settings.site_phone || '+254742432358'}`}>
                      {settings.site_phone || '+254 742 432 358'}
                    </a>
                  </p>
                </div>
                <div className="contact-item">
                  <p className="contact-label">EMAIL</p>
                  <p className="contact-value">
                    <a href={`mailto:${settings.site_email || 'hello@yamas.co.ke'}`}>
                      {settings.site_email || 'hello@yamas.co.ke'}
                    </a>
                  </p>
                </div>
                <div className="contact-item">
                  <p className="contact-label">ADDRESS</p>
                  <p className="contact-value">{settings.site_address || 'Mariano Giovannini Ave, Durban, East'}</p>
                </div>
              </div>
            </div>
            
            <div>
              <form onSubmit={handleSubmit}>
                <div style={{marginBottom: '20px'}}>
                  <input
                    type="text"
                    name="name"
                    placeholder="Your Name *"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    style={{width: '100%', padding: '15px', border: '1px solid #ddd', fontSize: '1rem'}}
                  />
                </div>
                <div style={{marginBottom: '20px'}}>
                  <input
                    type="email"
                    name="email"
                    placeholder="Your Email *"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    style={{width: '100%', padding: '15px', border: '1px solid #ddd', fontSize: '1rem'}}
                  />
                </div>
                <div style={{marginBottom: '20px'}}>
                  <input
                    type="text"
                    name="subject"
                    placeholder="Subject *"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                    style={{width: '100%', padding: '15px', border: '1px solid #ddd', fontSize: '1rem'}}
                  />
                </div>
                <div style={{marginBottom: '20px'}}>
                  <textarea
                    name="message"
                    placeholder="Your Message *"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="6"
                    style={{width: '100%', padding: '15px', border: '1px solid #ddd', fontSize: '1rem', resize: 'vertical'}}
                  />
                </div>
                <button 
                  type="submit" 
                  className="btn-primary" 
                  style={{width: '100%'}}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'SENDING...' : 'SEND MESSAGE'}
                </button>
                {submitMessage && (
                  <div style={{
                    marginTop: '20px',
                    padding: '15px',
                    backgroundColor: '#d4edda',
                    color: '#155724',
                    borderRadius: '4px',
                    border: '1px solid #c3e6cb'
                  }}>
                    {submitMessage}
                  </div>
                )}
                {submitError && (
                  <div style={{
                    marginTop: '20px',
                    padding: '15px',
                    backgroundColor: '#f8d7da',
                    color: '#721c24',
                    borderRadius: '4px',
                    border: '1px solid #f5c6cb'
                  }}>
                    {submitError}
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;
